import { RxStateComponent } from '@alliance/shared/models'
import { Component, ChangeDetectionStrategy } from '@angular/core'
import { Translations } from '../../localization/translations'
import { CarouselService } from '@alliance/shared/carousel-gallery'
import { IconRemoveCross } from '@alliance/shared/icons'
import { OnboardingCategoriesEnum } from '../../../domain/models/onboarding-categories.enum'
import { VisibilityStateService } from '../../../api'
import { ICONS_BY_CATEGORY_MAP } from '../../../domain/constants/icons-by-categroy-map'

@Component({
  selector: 'lib-categories-panel',
  templateUrl: './categories-panel.component.html',
  styleUrls: ['./categories-panel.component.tw.css'],
  providers: [CarouselService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CategoriesPanelComponent extends RxStateComponent<{ activeCategory: OnboardingCategoriesEnum | null }> {
  public readonly ICONS = { IconRemoveCross }
  public readonly ICONS_BY_CATEGORY_MAP = ICONS_BY_CATEGORY_MAP
  public readonly CATEGORIES: OnboardingCategoriesEnum[] = Object.values(OnboardingCategoriesEnum)
  public readonly state = this.connectViewState(['activeCategory'])
  public constructor(public translations: Translations, private visibilityStateService: VisibilityStateService) {
    super()

    this.initState({
      activeCategory: this.visibilityStateService.select('activeCategory')
    })
  }

  public activateCategory(activeCategory: OnboardingCategoriesEnum): void {
    this.visibilityStateService.setActiveCategory(activeCategory)
  }

  public close(): void {
    this.visibilityStateService.close()
  }

  public trackByFn(index: number, item: OnboardingCategoriesEnum): string {
    return `${index}_${item}`
  }
}
